// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"Gu-z","giftOrPromoSelector":"Hu-z","disabled":"Iu-z","subTitle":"Ju-z","selectShipAddressMessage":"Ku-z","changePayment":"Lu-z"};